module.exports = __webpack_public_path__ + "img/interstitial_4.a2043c14.jpg";